import { useState } from "react";
import { CheckCircle2, Loader2 } from "lucide-react";
import { sendLinkCode, verifyLinkCode } from "@/lib/api";

export default function LinkWhatsApp({ linkedPhone, onLinked }) {
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [step, setStep] = useState(linkedPhone ? "linked" : "phone");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const sendCode = async () => {
    setBusy(true);
    setMsg("");
    try {
      await sendLinkCode(phone);
      setStep("code");
      setMsg("Code WhatsApp pe bheja gaya ✓");
    } catch (e) {
      setMsg(e?.response?.data?.detail || "Code send nahi hua, dubara try karo");
    }
    setBusy(false);
  };

  const verify = async () => {
    setBusy(true);
    setMsg("");
    try {
      const { data } = await verifyLinkCode(phone, code.trim());
      setStep("linked");
      if (onLinked) onLinked(data);
    } catch (e) {
      setMsg(e?.response?.data?.detail || "Verify nahi hua, dubara try karo");
    }
    setBusy(false);
  };

  if (step === "linked") {
    return (
      <div data-testid="link-phone-linked" className="flex items-center gap-2 bg-[#006D5B]/8 border border-[#006D5B]/20 rounded-xl p-3">
        <CheckCircle2 size={16} className="text-[#006D5B]" />
        <div className="text-[12px] text-left">
          <p className="font-bold text-[#006D5B]">WhatsApp linked ✓</p>
          <p className="text-gray-500 font-mono">+{linkedPhone || phone}</p>
        </div>
      </div>
    );
  }
  return (
    <div className="space-y-2">
      {step === "phone" ? (
        <>
          <div className="flex gap-2">
            <input
              data-testid="link-phone-input"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="10-digit WhatsApp number"
              className="flex-1 min-w-0 border border-gray-200 rounded-full px-3.5 py-2 text-[12px] outline-none focus:ring-2 focus:ring-[#006D5B]/40"
            />
            <button data-testid="link-send-code-btn" onClick={sendCode} disabled={busy || phone.trim().length < 10}
              className="bg-[#006D5B] text-white text-[11px] font-bold px-4 py-2 rounded-full disabled:opacity-50 shrink-0">
              {busy ? <Loader2 size={13} className="animate-spin" /> : "Code bhejo"}
            </button>
          </div>
          <button data-testid="link-have-code-btn" onClick={() => setStep("code")}
            disabled={phone.trim().length < 10}
            className="text-[10px] text-[#006D5B] font-semibold underline disabled:opacity-40">
            Code already mila? Yahan enter karo →
          </button>
        </>
      ) : (
        <div className="flex gap-2">
          <input
            data-testid="link-code-input"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="6-digit code"
            maxLength={6}
            className="flex-1 min-w-0 border border-gray-200 rounded-full px-3.5 py-2 text-[12px] font-mono tracking-widest outline-none focus:ring-2 focus:ring-[#006D5B]/40"
          />
          <button data-testid="link-verify-btn" onClick={verify} disabled={busy || code.trim().length !== 6}
            className="bg-[#006D5B] text-white text-[11px] font-bold px-4 py-2 rounded-full disabled:opacity-50 shrink-0">
            {busy ? <Loader2 size={13} className="animate-spin" /> : "Verify"}
          </button>
          <button data-testid="link-resend-btn" onClick={sendCode} disabled={busy}
            className="text-[10px] text-gray-400 font-semibold underline shrink-0">resend</button>
        </div>
      )}
      {msg && <p data-testid="link-status-msg" className="text-[11px] text-gray-500 text-left">{msg}</p>}
    </div>
  );
}
